import React, { useEffect, useState } from 'react';
import moment from 'moment';
import {
    Tabs,
    Row,
    Col,
    DatePicker,
    Spin
} from 'antd'
import {
    LeftOutlined
} from '@ant-design/icons';
import UIFetchService from '../Service/UIFetchService';
import ReactEcharts from 'echarts-for-react';
import './EventAnalysis.css'
import auth from '../Service/AuthFetchService';

const FunnelDataView = (props) => {

    const [funnel, setFunnel] = useState(null)
    const [user, setUser] = useState(null)

    useEffect(() => {
        const d8 = moment().subtract(8, 'days')
        const yesterday = moment().subtract(1, 'days')

        UIFetchService.get(`/api/v1/sampling/funnel/detail/${props.funnelId}`)
            .then((result) => {
                if (result) {
                    setFunnel({
                        id: result.id,
                        name: result.name,
                        steps: JSON.parse(result.funnelSteps),
                        creator: result.creator,
                        dataUpdatedAt: result.dataUpdatedAt,
                        status: result.status,
                        rangeDate: result.rangeDate == null ? [d8, yesterday] : JSON.parse(result.rangeDate).map(d => moment(d, 'YYYY-MM-DD'))
                    })
                }
            })
        if (user == null) {
            auth.authenticate()
                .then((result) => {
                    if (result) {
                        setUser(result)
                    }
                })
        }
    }, [props.funnelId])

    useEffect(() => {
        if (funnel != null && user != null) {
            window.CyaLogger?.sendCustomEvent('page_view', '漏斗分析', 'details_view', {
                event_date: moment().format('YYYY-MM-DD'),
                user_name: user.account,
                funnel_name: funnel.name,
                funnel_id: props.funnelId
            })
        }
    }, [funnel, user])

    return (
        <>
        <Row style={{ textAlign: 'left', padding: '0 10px 0 10px', margin: '0 0 10px 0' }}>
            <Col style={{ margin: '0 20px 0 0' }}>
                <span
                    style={{
                        color: 'gray',
                        cursor: 'pointer'
                    }}
                    onClick={() => window.location = '/real_time/funnel_analysis'}
                ><LeftOutlined /> 返回</span>
            </Col>
            <Col>
                <span>漏斗数据</span>
            </Col>
        </Row>
        {funnel == null ? null : 
            <>
                {funnel.status === 2 ? 
                <>
                <Row justify='center'>
                    <Col>
                        <img src="/no_event_data.png"></img>
                    </Col>
                </Row>
                <span>漏斗计算中，请稍后查看</span> 
                </>
                : 
                <>
                <Row justify='left' style={{margin: '40px 30px 20px 20px'}}>
                    <Col style={{marginTop: -3}}>
                        <span style={{fontWeight:700, fontSize: 18}}>{funnel.name}</span>
                    </Col>
                    <Col flex="200px">
                        <span>创建人：{funnel.creator}</span>
                    </Col>
                    <Col flex="200px">
                        <span>数据更新时间：{moment(funnel.dataUpdatedAt).format('YYYY-MM-DD')}</span>
                    </Col>
                </Row>
                <div style={{ 
                    margin:'20px 15px 20px 15px', 
                    border: '1px solid #eee',
                    padding: '20px 10px',
                    boxShadow: '5px 5px 5px #ccc'
                }}>
                    <FunnelChartView funnel={funnel} /> 
                </div>
                </> }
            </> 
        }
        </>
    )
}

function FunnelChartView(props) {
    const [chartType, setChartType] = useState('history')
    const [loading, setLoading] = useState(false)
    const [rangeDate, setRangeDate] = useState([undefined, undefined])
    const [chartDataHistory, setChartDataHistory] = useState(null)
    const [chartDataToday, setChartDataToday] = useState(null)

    useEffect(() => {
        setChartDataHistory(null)
        setChartDataToday(null)
        const funnel = props.funnel
        console.info(funnel.rangeDate)
        // const dateFormat = 'YYYY-MM-DD'
        setRangeDate(funnel.rangeDate)
        if (funnel != null && funnel.id != null && funnel.steps != null) {
            _doQuery()
        }
    }, [props.funnel])

    useEffect(() => {
        if (chartType === 'history' && chartDataHistory != null ||
            chartType === 'today' && chartDataToday != null) {
                return
            }
        
        const funnel = props.funnel
        if (funnel != null && funnel.id != null && funnel.steps != null) {
            _doQuery()
        }
    }, [chartType])

    const chartTypeChange = (t) => {
        setChartType(t)
    }
    
    const _doQuery = async () => {
        const funnel = props.funnel
        setLoading(true)
        if (chartType === 'history') {
            const result = await UIFetchService.get(`/api/v1/sampling/funnel/data/${funnel.id}`)
            if (result == null || Object.keys(result).length === 0) {
                setLoading(false)
                return
            }
            setChartDataHistory(result)
        } else {
            const requestBody = { 
                type: chartType, 
                funnelId: funnel.id,
                conditions: funnel.steps.map(s => { 
                    return {
                        id: s.id,
                        projectName: s.projectName, 
                        eventGroup: s.classificationType === '事件分组' ? s.classificationValue : null,
                        eventName: s.eventName, 
                        statisticObject: s.statisticObject,
                        propertiesSelector: s.propertiesSelector
                    }
                })
            }
    
            const today = moment()
            requestBody.startDate = today.format('YYYY-MM-DD')
            requestBody.endDate = today.format('YYYY-MM-DD')
            const result = await UIFetchService.post('/api/v1/sampling/funnel/query', requestBody)
            if (result == null || Object.keys(result).length === 0) {
                setLoading(false)
                return
            }
            setChartDataToday(result.data)
        }

        setLoading(false)
    }

    return (
        <>
            <Spin spinning={loading}>
            <Row style={{padding: '0 10px'}}>
                <Col span={24}>
                    <Tabs 
                        style={{ textAlign: 'left', padding: '0 6px 0 6px' }} 
                        activeKey={chartType} 
                        onChange={(t) => chartTypeChange(t)}
                        className='event-chart-tabs'
                    >
                        <Tabs.TabPane tab="今日实时" key='today'>
                            <div style={{height: 15}}></div>
                            { 
                                chartType !== 'today' || loading ? null : 
                                    <FunnelChart chartData={chartDataToday} />
                            }
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="历史数据" key='history'>
                            <div style={{height: 15}}></div>
                            <DatePicker.RangePicker disabled
                                style={{margin: '10px 10px 0 0'}}
                                value={rangeDate} 
                            /> 
                            { 
                                chartType !== 'history' || loading ? null :
                                    <FunnelChart chartData={chartDataHistory} /> 
                            }
                        </Tabs.TabPane>
                    </Tabs>
                </Col>
            </Row>
            </Spin>
        </>
    )
}

function FunnelChart(props) {
    const colors = [
        '#63b2ee',
        '#76da91',
        '#f8cb7f',
        '#f89588',
        '#7cd6cf',
        '#9192ab',
        '#7898e1',
        '#efa666',
        '#eddd86',
        '#9987ce',
        '#63b2ee',
        '#76da91']
    const [chartOption, setChartOption] = useState({
        color: colors,
        legend: {
            orient: 'vertical',
            height: 55,
            data: [],
            icon: 'circle'
        },
        xAxis: {
            type: 'category',
            data: [],
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#8c8c8c'
                }
            },
            axisTick: { 
                show: true,
                lineStyle: {
                    color: '#8c8c8c',
                }
            }
        },
        yAxis: {
            type: 'value',
            axisTick:{ //y轴刻度线
                show:false
            },
            axisLine:{ //y轴
                show:false
            },
            axisLabel: {//y轴文字的配置
                textStyle: {
                     color: "#8c8c8c",
                     margin: 15
                },
            },
            splitLine: {
                lineStyle: {
                    color: '#F5F7F8'
                }
            }
        },
        grid: {
            left: 80
        },
        tooltip: {
            trigger: 'axis',
            formatter: function(params) {
                // console.info(params)
                let res = params[0].name + '<br/>';
                for(let i = 0, length = params.length; i < length; i++) {
                    let ratio = toPercent(params[i].data.ratio)
                    let stepName = ''

                    if (i < params.length - 1) {
                        stepName = `第${i + 1}步转化`
                    } else {
                        stepName = '总体转化'
                    }

                    res += `${params[i].marker} ${params[i].seriesName}: ${params[i].value} &nbsp;&nbsp;&nbsp;&nbsp; ${stepName}: ${ratio} <br/>`;
                }
                return res;
            }
        },
        series: [
            {
                data: [],
                type: 'line',
                smooth: 0.5
            }
        ]   
    })

    useEffect(() => {
        const chartData = props.chartData
        if (chartData != null && chartData.eventData != null) {
            renderChart(chartData)
        }
    }, [props.chartData])

    const renderChart = (data) => {
        const eventData = data.eventData
        const eventDataValues = Object.values(eventData)
        const ratioData = data.ratioData

        const keys = Object.keys(eventData)
        if (keys == null || keys.length === 0) {
            return
        }
        let option = JSON.parse(JSON.stringify(chartOption))
        option.legend.data = keys
        option.xAxis.data = eventDataValues[0].map(a => a.time.length === 10 ? a.time.substring(5) : a.time)
        option.series = eventDataValues.map((a,i) => { 
            return { 
                name: keys[i],
                showSymbol: false, 
                // data: a.map(e => e.value != null ? e.value : 0), 
                data: a.map((e, j) => {
                    return {
                        value: e.value != null ? e.value : 0,
                        ratio: ratioData[(i + 1) % eventDataValues.length][j].value 
                    }
                }),
                type: 'line', 
                smooth: 0.3,
            }
        })

        setChartOption(option)
    }

    const toPercent = (decimal) => {
        return (Math.round(decimal * 10000) / 100) + '%'
    }

    return <>
        <Row>
            <Col flex="450px">
            {
                props.chartData != null &&
                props.chartData.totalRatioData != null &&
                Object.keys(props.chartData.totalRatioData).map(index => <div key={index}>
                <Row justify='center'>
                    <Col>
                        {index == 0 ?
                            <div className="funnel-ratio" style={{ background: 'url("/funnel_ratio.svg")'}}>
                                <div>总转化率</div>
                                <span>{ toPercent(props.chartData.totalRatioData[index].ratio) }</span>
                            </div> :
                            <div className="funnel-ratio" style={{ height: 46, background: 'url("/funnel_step_ratio.svg")'}}>
                                <span>{ toPercent(props.chartData.totalRatioData[index].ratio) }</span>
                            </div> 
                        }
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="funnel-step">
                            <div className='funnel-step-key-div'>
                            <span className='funnel-step-key'>{Object.keys(props.chartData.eventData)[index]}</span>
                            </div>
                            <div>
                            <span className='funnel-step-count'>{props.chartData.totalRatioData[index].count}</span>
                            </div>
                        </div>
                    </Col>
                </Row>
                </div>)
            }
            </Col>
            <Col flex="auto">
                <ReactEcharts option={chartOption} style={{height: 450}} />
            </Col>
        </Row>
    </>
}

export default FunnelDataView
